import React from 'react'
import StarRatings from 'react-star-ratings';
const Rating = ({ rating }) => {
    const colSize = rating?.review ? "col-md-4" : "col-md-6";
    return (

        <div className="border rounded-3 p-3 shadow-sm mt-3" style={{ borderWidth: '2px' }}>
            <div className="row">
                <div className={`${colSize} mb-2`}>
                    <div className="fw-semibold">Delivery Rating</div>
                    <StarRatings
                        rating={rating.delivery ?? 0}
                        starRatedColor="#ffd700"
                        numberOfStars={5}
                        name="delivery-rating"
                        starDimension="24px"
                        starSpacing="2px"
                    />
                </div>
                <div className={colSize}>
                    <div className="fw-semibold">Order Rating</div>
                    <StarRatings
                        rating={rating.order ?? 0}
                        starRatedColor="#ffd700"
                        numberOfStars={5}
                        name="order-rating"
                        starDimension="24px"
                        starSpacing="2px"
                    />
                </div>

                {rating?.review && (
                    <div className="col-md-4">
                        <div className="fw-semibold">Review</div>
                        <div className="text-muted">{rating?.review || "N/A"}</div>
                    </div>
                )}

            </div>
        </div>
    )
}

export default Rating